<template>
  <div class="container">
    <div class="box">
      <div class="columns is-multiline" v-if="accommodation">
        <div class="column is-8">
          <div class="columns is-multiline">
            <div class="column is-12">
              <div class="field">
                <label class="label">Name</label>
                <div class="control">
                  <input type="text" class="input" placeholder="Title" v-model="accommodation.name">
                </div>
              </div>
            </div>
            <div class="column is-12">
              <div class="field">
                <label class="label">Tagline</label>
                <div class="control">
                  <input type="text" class="input" placeholder="Title" v-model="accommodation.tagline">
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <p class="heading">Maximum Number of Guests</p>
                <div class="control">
                  <input type="number" class="input" placeholder="0" v-model="accommodation.numberOfGuests" min="0">
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <p class="heading">Linked Property</p>
                <div class="control has-icons-left">
                  <div class="select">
                    <select v-model="accommodation.property">
                      <option value="null">Select Property</option>
                      <option v-for="property in properties" :key="property['.key']" :value="property['.key']">{{property.name}}</option>
                    </select>
                  </div>
                  <div class="icon is-small is-left">
                    <i class="fa fa-home"></i>
                  </div>
                </div>
              </div>
            </div>

            <div class="column is-4">
              <div class="field">
                <p class="heading">Guests</p>
                <div class="control">
                  <input type="number" class="input" placeholder="0" v-model="accommodation.numberOfGuests" min="0">
                </div>
              </div>
            </div>
            <div class="column is-4">
              <div class="field">
                <p class="heading">Rooms</p>
                <div class="control">
                  <input type="number" class="input" placeholder="0" v-model="accommodation.numberOfRooms" min="0">
                </div>
              </div>
            </div>
            <div class="column is-4">
              <div class="field">
                <p class="heading">Bath Rooms</p>
                <div class="control">
                  <input type="number" class="input" placeholder="0" v-model="accommodation.numberOfBathrooms" min="0">
                </div>
              </div>
            </div>

            <div class="column is-12">
              <div class="field">
                <label class="label">About</label>
                <div class="control">
                  <!-- rich text vue-quill-editor plugin -->
                  <quill-editor v-model="accommodation.about" :options="editorOptions">
                  </quill-editor>
                  <input type="file" id="getImage" style="display: none;" @change="uploadImage">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="columns is-multiline">
            <div class="column is-12">
              <div class="field">
                <div class="control">
                  <label class="label">Featured Image</label>
                  <figure class="image is-5by4" v-if="accommodation.featuredImage">
                    <img :src="accommodation.featuredImage">
                  </figure>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <div class="file">
                    <label class="file-label">
                      <input @change="uploadImages" class="file-input" type="file" name="resume"
                             accept=".jpg, .jpeg, .png"/>
                      <span class="file-cta">
                      <span class="file-icon">
                        <i class="fa fa-upload"></i>
                      </span>
                      <span class="file-label">
                        Choose a Featured Image…
                      </span>
                    </span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="field">
                <p class="heading">Accommodation Gallery</p>
                <div class="control has-icons-left">
                  <div class="select">
                    <select v-model="accommodation.gallery">
                      <option value="null">Select Gallery</option>
                      <option v-for="gallery in galleries" :key="gallery['.key']" :value="gallery['.key']">{{gallery.title}}</option>
                    </select>
                  </div>
                  <div class="icon is-small is-left">
                    <i class="fa fa-picture-o"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- the form buttons -->
      <button type="submit" class="button is-success" @click="addAccommodation('published')">Publish</button>
      <button type="submit" class="button is-info" @click="addAccommodation('saved')">Save Draft</button>
      <router-link to="/admin/accommodations" class="button is-danger">Cancel</router-link>

      <!-- notification -->
      <transition mode="out-in" name="fade">
        <div v-if="notification.message" :class="'notification is-' + notification.type">
          <button class="delete" @click="hideNotifications"></button>
          {{notification.message}}
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import {mediaRef, accommodationsRef, galleriesRef, propertiesRef} from '@/firebase_config'
import notifier from '@/mixins/notifier'
import editorOptions from './editor-options'
import imageLoader from '@/mixins/image-loader'

export default {
  name: 'user-accommodation-new',
  data () {
    return {
      currentUser: firebase.auth().currentUser,
      accommodation: {
        name: '',
        tagline: '',
        about: '',
        featuredImage: null,
        gallery: null,
        numberOfGuests: 0,
        numberOfRooms: 0,
        numberOfBathrooms: 0
      },
      editorOptions
    }
  },
  firebase: {
    media: mediaRef,
    galleries: galleriesRef,
    properties: propertiesRef
  },
  mixins: [imageLoader, notifier],
  methods: {
    addAccommodation (state) {
      this.accommodation.state = state
      let tempData = {
        ...this.accommodation,
        createdBy: this.currentUser.uid,
        createdOn: (new Date()).toISOString()
      }
      accommodationsRef.push(tempData).then(() => {
        this.showNotification('success', 'Testimonial added successfully')
      })
    },
    uploadImages (e) {
      let files = e.target.files
      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        this.uploadImage(file)
      }
    },
    uploadImage (file) {
      let storageRef = firebase.storage().ref('images/accommodations/' + file.name)
      let uploadTask = storageRef.put(file)

      uploadTask.then(this.addImageToMedia)
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, this.handleUploadProgress, this.handleUploadError, this.handleUploadComplete)
    },
    handleUploadProgress (snapshot) {
      let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      this.showNotification('success', 'Uploading image ' + Math.floor(progress) + '% done.')

      switch (snapshot.state) {
        case firebase.storage.TaskState.PAUSED: // or 'paused'
          console.log('Upload is paused')
          break
        case firebase.storage.TaskState.RUNNING: // or 'running'
          console.log('Upload is running')
          break
      }
    },
    handleUploadError (error) {
      switch (error.code) {
        case 'storage/unauthorized':
          console.log('storage/unauthorized')
          // User doesn't have permission to access the object
          break
        case 'storage/canceled':
          console.log('storage/canceled')
          // User canceled the upload
          break
        case 'storage/unknown':
          console.log('storage/unknown')
          // Unknown error occurred, inspect error.serverResponse
          break
        default:
          console.log(error)
      }
    },
    handleUploadComplete () {
      console.log('Upload Complete!')
    },
    addImageToMedia (snapshot) {
      this.showNotification('success', snapshot.metadata.name + ' uploaded.')

      let mediaObj = {
        src: snapshot.downloadURL,
        path: snapshot.ref.fullPath,
        name: snapshot.metadata.name,
        contentType: snapshot.metadata.contentType,
        createdBy: this.currentUser.uid,
        createdOn: (new Date()).toISOString()
      }

      this.accommodation.featuredImage = snapshot.downloadURL

      mediaRef.push(mediaObj)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .gallery {
    margin: 16px;
  }

  .img-container {
    display: block;
    position: relative;
    width: 100%;
    padding-bottom: 100%;
  }

  .delete-button {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 1;
  }

  .info-tab {
    position: absolute;
    bottom: 0px;
    height: 28px;
    width: 100%;
    padding: 4px;
    background-color: black;
    color: white;
    opacity: 0.71;
    z-index: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .image-div {
    position: absolute;
    width: 100%;
    height: 100%;
    background-size: cover;
    z-index: 0;
  }

  .service {
    background: #efefef;
    padding: 8px;
    border-radius: 4px;
    &__title {
      display: block;
      width: 100%;
      min-width: 240px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/content/AccommodationsNew.vue